import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <polygon points="23.9,12.5 1,25 1,0 " />
    </g>
  </svg>
);
